import Checkbox from '@creditflowresearch/uilib/Checkbox';
import FilterSection from '@/creditflowresearch/ui/common/components/templates/FilterSection';
import FilterSectionHeader from '@/creditflowresearch/ui/common/components/organisms/FilterSectionHeader';
import FilterItem from '@/creditflowresearch/ui/common/components/FilterItem';
import { FilterSectionIds } from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/constants';
import useRatingsSection from './useRatingsSection';

import styles from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/styles/checkboxFilter.module.scss';

const Ratings = () => {
  const { items, selectedValues, isAllSelected, isIndeterminate, toggle, toggleAll, isAbsolute, onToggleAbsolute } = useRatingsSection();

  return (
    <FilterSection
      sectionId={ FilterSectionIds.Ratings }
      header={ (
        <FilterSectionHeader
          title="RATINGS"
          leftSlot={ (
            <Checkbox
              checked={ isAllSelected }
              onChange={ toggleAll }
              indeterminate={ isIndeterminate }
              supportIndeterminate
              dataTest="ratingsFiltersAllCheckbox"
            />
          ) }
          rightSlot={ (
            <Checkbox
              label="Absolute Filter"
              checked={ isAbsolute }
              onChange={ onToggleAbsolute }
              dataTest="ratingsAbsoluteFilterCheckbox"
            />
          ) }
        />
      ) }
    >
      <div className={ styles.columns4 }>
        { items.map((item) => (
          <FilterItem key={ item.value } isExpandable={ false }>
            <Checkbox
              label={ item.name }
              checked={ selectedValues.includes(item.value) }
              onChange={ () => toggle(item.value) }
              dataTest={ `checkbox-rating-${ item.value }` }
            />
          </FilterItem>
        )) }
      </div>
    </FilterSection>
  );
};

export default Ratings;
